import React, { useState } from "react";

const EmailIntegration = () => {
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const sendEmail = () => {
    // Implement email sending logic here (likely via backend API)
    alert(`Email sent to ${to}`);
  };

  return (
    <div>
      <h2>Email Integration</h2>
      <input
        type="email"
        value={to}
        onChange={(e) => setTo(e.target.value)}
        placeholder="Recipient Email"
      />
      <input
        type="text"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
        placeholder="Subject"
      />
      <textarea
        value={body}
        onChange={(e) => setBody(e.target.value)}
        placeholder="Email Body"
      />
      <button onClick={sendEmail}>Send Email</button>
    </div>
  );
};

export default EmailIntegration;
